module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-L-31.f47cb8f1.png";